import { render, staticRenderFns } from "./surat_ttd.vue?vue&type=template&id=1ac086ac&"
import script from "./surat_ttd.vue?vue&type=script&lang=js&"
export * from "./surat_ttd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports